import { render, staticRenderFns } from "./purchaseOrderContainerPurchaseList.vue?vue&type=template&id=12358dd2&"
import script from "./purchaseOrderContainerPurchaseList.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderContainerPurchaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports